import React, { useState } from "react";
import { useInView } from "react-intersection-observer";

const faqs = [
  {
    q: "Is the download safe?",
    a: "Yes. The installer is code-signed with a verified publisher, served over HTTPS, and scanned clean by antivirus. It passes Windows SmartScreen on fresh devices — no scary warnings.",
  },
  {
    q: "How do I install it?",
    a: "Download the .exe, double-click to run, and follow the setup wizard. Installation takes under a minute.",
  },
  {
    q: "Which Windows versions are supported?",
    a: "Zero Typing works on Windows 10 (64-bit) and Windows 11.",
  },
  {
    q: "Does it need microphone access?",
    a: "Yes — Windows will prompt for microphone permission the first time you use voice typing.",
  },
  {
    q: "Can I cancel whenever I want?",
    a: "Absolutely. Cancel anytime from your account settings. No questions asked.",
  },
  {
    q: "What if I get stuck during install?",
    a: "Reach out via the Help page — our team responds within a few hours during business days.",
  },
];

const FAQItem = ({ q, a, open, onToggle, animate, delay }) => (
  <div
    style={{ animationDelay: `${delay}ms` }}
    className={`${
      animate ? "animate-slideUp z-[3] anim-preserve" : "opacity-0 z-0"
    } rounded-2xl border border-[#0000000D] transition-all ${
      open ? "bg-[#F3F8FD]" : "bg-[#F9F9F9]"
    }`}
  >
    <button
      onClick={onToggle}
      className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
    >
      <span className="font-inter font-semibold text-[#0F1B2D] text-[0.95rem] sm:text-[1rem]">
        {q}
      </span>
      <span className="text-[#33425A] text-xl font-light shrink-0">
        {open ? "×" : "+"}
      </span>
    </button>
    {open && (
      <div className="px-5 pb-4 font-inter text-[#33425A] text-[0.875rem] sm:text-[0.9375rem] leading-[1.55]">
        {a}
      </div>
    )}
  </div>
);

const FAQSection = () => {
  const [openIdx, setOpenIdx] = useState(-1);
  const { ref: headRef, inView: headView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });
  const { ref: listRef, inView: listView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section className="w-full max-w-[820px] mx-auto md:px-7 px-4 flex flex-col gap-8">
      <h2
        ref={headRef}
        className={`${
          headView ? "animate-slideUp z-[3] anim-preserve" : "opacity-0 z-0"
        } font-jakarta font-extrabold text-[#0F1B2D] text-center text-[2.625rem] md:text-[2.4rem] lg:text-[2.8rem] xl:text-[3.125rem] leading-[1.24] tracking-[-0.02em]`}
      >
        Questions,{" "}
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#3AB1F6] to-[#407BFF]">
          Answered.
        </span>
      </h2>

      <div
        ref={listRef}
        className="flex flex-col gap-3"
      >
        {faqs.map((f, i) => (
          <FAQItem
            key={i}
            q={f.q}
            a={f.a}
            open={openIdx === i}
            onToggle={() => setOpenIdx(openIdx === i ? -1 : i)}
            animate={listView}
            delay={i * 100}
          />
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
